import Vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios'
import i18n from '../plugins/i18n'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {features: {}, uiSettings: {}},
    activePatients: [],

    modalVisible: false,
    modalComponent: null,
    modalTitle: '',
    modalData: {},

    selectedPatient: null,
    selectedMedicalDataType: null,

    devices: [],

    login: [],
    device: [],
    data: [],
    patients: [],
    allPatients: [],

    ecgActiveDevice: null,
    ecgData: [],
    availableDataTypes: [],
  },

  getters: {
    getDeviceById: (state) => (id) => {
      return state.devices.find(device => device.id === id)
    },
    getPatientById: (state) => (id) => {
      return state.activePatients.find(patient => patient.id === id)
    },
    getPatientByDeviceId: (state) => (deviceId) => {
      return state.activePatients.find(patient => patient.devices_ids && patient.devices_ids.includes(deviceId))
    },
    isAvailableDataType: state => type =>
      // why this project contains such blood_pressure components(
      !!state.availableDataTypes.find(x => x.value === type || (type === 'blood_pressure' && ['bp_sys', 'bp_dia'].includes(x.value))),
  },

  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setActivePatients(state, patients) {
      state.activePatients = patients
    },

    showModal(state, {componentName, modalTitle, modalData}) {
      //console.log('Show modal', componentName, modalTitle, modalData)
      state.modalVisible = true
      state.modalComponent = componentName
      state.modalTitle = modalTitle
      state.modalData = modalData
    },
    hideModal(state) {
      state.modalVisible = false
    },

    setSelectedPatient(state, patient) {
      state.selectedPatient = patient
    },

    setSelectedMedicalDataType(state, type) {
      console.log('store setSelectedMedicalDataType', type)
      state.selectedMedicalDataType = type
    },

    setActiveTab(state, activeTab) {
      state.modalData.activeTab = activeTab
    },

    setDevices(state, devices) {
      state.devices = devices
    },

    setPatients(state, patients) {
      state.patients = patients
    },

    setLastTest(state, testInfo) {
      state.lastTest = testInfo
    },

    SET_DEVICE(state, device) {
      state.device = device
    },
    SET_LOGIN(state, login) {
      state.login = login
    },
    SET_ALL_PATIENTS(state, allPatients) {
      state.allPatients = allPatients
    },

    addDevice: (state, testData) => {
      state.data.push(testData)
      console.log('Added Product:', testData)
      console.log('products', state.data)
    },

    clearEcgData(state) {
      state.ecgData = []
    },

    setEcgActiveDevice(state, deviceId) {
      state.ecgActiveDevice = deviceId
    },

    setEcgData(state, data) {
      if (!data) {
        return
      }
      const newLines = data.map((row) => {
        return {
          x: row[1],
          y: row[0]
        }
      })
      state.ecgData = state.ecgData.concat(newLines)
    },

    setAvailableDataTypes(state, types) {
      state.availableDataTypes = types.map(x => ({value: x.value, text: i18n.t(x.text) || x.text}))
    },
  },

  actions: {
    loadDevices({commit}) {
      axios.get('/api/devices/').then(res => res.data.data).then(devices => {
        commit('setDevices', devices)
      })
    },
    loadActivePatients({commit, dispatch}) {
      return axios.get('/api/medical/patients/active').then(res => res.data.data.rows).then(patients => {
        commit('setActivePatients', patients)
        return dispatch('loadActivePatientsMedicalData').then(() => {
          return dispatch('loadActivePatientsMedicalTestData')
        })
      })
    },
    loadActivePatientsMedicalData({commit, state}) {
      let promises = []
      state.activePatients.forEach((patient) => {
        promises.push(axios.get(`/api/medical/patients/${patient.id}/lastMedicalData`)
          .then(res => res.data.data)
          .then(medicalData => {
            Vue.set(patient, 'medicalData', medicalData)
          }))
      })
      return Promise.all(promises)
    },
    loadActivePatientsMedicalTestData({dispatch, state}) {
      let promises = []
      state.activePatients.forEach((patient) => {
        promises.push(dispatch('loadPatientMedicalTest', patient))
      })
      return Promise.all(promises)
    },
    loadPatientMedicalTest({commit}, patient) {
      return axios.get(`/api/medical/lastTest/${patient.devices_ids[0]}`)
        .then(res => res.data.data)
        .then(testData => {
          // if (testData.patient_id === patient.id) {
          Vue.set(patient, 'lastTest', testData)
          // }
        })
    },
    loadPatients({commit}) {
      return axios.get('/api/medical/patients/', {params: {recordsPerPage: -1}}).then(res => res.data.data.rows)
        .then(patients => {
          commit('setPatients', patients)
          return patients
        })
    },
    loadLogin({commit}) {
      axios.post('/api/login/').then(res => res.data.data).then(login => {
        commit('SET_LOGIN', login)
      })
    },

    SOCKET_medicine_data({commit, state, dispatch, getters}, data) {
      if (!data.deviceId) {
        return
      }
      if (data.type === 'activeTestUpdate') {
        let activeTestData = data.data
        if (activeTestData.patient_id) {
          let patient = getters.getPatientById(parseInt(activeTestData.patient_id))
          if (patient) {
            // console.log('activeTestData update', activeTestData, patient.lastTest)
            if (!patient.lastTest || patient.lastTest.id !== activeTestData.id) {
              dispatch('loadPatientMedicalTest', patient)
            } else {
              if (patient.status !== activeTestData.status && activeTestData.status && activeTestData.status === 'CNT') {
                Vue.notify({text: i18n.t('TEST_STATUS_' + activeTestData.status), type: 'success'})
              }
              Vue.set(patient, 'lastTest', activeTestData)
            }
          }
        }
        return
      }
      state.activePatients.forEach((patient) => {
        patient.devices_ids.forEach((deviceId) => {
          if (deviceId === data.deviceId && patient.medicalData) {
            Object.assign(patient.medicalData, data.data)
            Vue.set(patient, 'medicalData', patient.medicalData)
            if (data.data.ecg) {
              commit('setEcgData', data.data.ecg.data)
            }
          }
        })
      })
    },

    SOCKET_patients_updated({commit, state, dispatch, getters}, data) {
      console.log('SOCKET_patients_updated', data)
      if (['patient_added', 'patient_updated', 'patient_deleted'].includes(data.event)) {
        dispatch('loadActivePatients')
        dispatch('loadDevices')
      } else if (data.event === 'alarms_viewed') {
        let patient = getters.getPatientById(parseInt(data.patient_id))
        console.log('alarms_viewed patient', patient)
        if (patient && patient.medicalData) {
          patient.medicalData.unwatchedAlarmsCnt = '0'
          patient.medicalData.unwatchedAlarmsLevel = ''
          Vue.set(patient, 'medicalData', patient.medicalData)
        }
      }
    },

    SOCKET_new_alarm({commit, state, dispatch, getters}, data) {
      console.log('SOCKET_new_alarm', data)
      let patient = getters.getPatientByDeviceId(parseInt(data.deviceId))
      console.log('SOCKET_new_alarm', data, patient)
      if (patient && patient.medicalData) {
        patient.medicalData.unwatchedAlarmsCnt++
        if (patient.medicalData.unwatchedAlarmsLevel !== 'red') {
          patient.medicalData.unwatchedAlarmsLevel = data.data && data.data.alarmParams && data.data.alarmParams.level || 'red'
        }

        Vue.set(patient, 'medicalData', patient.medicalData)
      }
    },

    SOCKET_device_updated({commit, state, dispatch, getters}, data) {
      if (data.type === 'online_status') {
        const device = getters.getDeviceById(data.deviceId);
        if (device) {
          Vue.set(device, 'is_online', data.data.status === 'device_online' ? 1 : 0)
        }
      }
    },

    loadLastTest({commit}) {
      axios.get('/api/medical/lastTest/{deviceId}').then(res => res.data.data).then(lastTest => {
        commit('setLastTest', lastTest)
      })
    },

    async addData({commit}, testData) {
      try {
        commit('addDevice', testData)
      } catch (error) {
        console.error(error)
      }
    },

    shiftEcgData({state}) {
      return state.ecgData.shift()
    },

    loadDataTypes({commit}) {
      axios.get('/api/medical/getAvailableDataTypes').then(res => res.data.data).then(types => {
        commit('setAvailableDataTypes', types)
      })
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js